const DEFAULT_IDLE_TIMEOUT_MINUTES = 120;

const configuredMinutes = Number(
  (window as any)._env_?.REACT_APP_SESSION_IDLE_TIMEOUT_MINUTES
);

const idleTimeoutMinutes =
  Number.isFinite(configuredMinutes) && configuredMinutes > 0
    ? configuredMinutes
    : DEFAULT_IDLE_TIMEOUT_MINUTES;

export const idleTimeoutMs = idleTimeoutMinutes * 60 * 1000;

export const RENEWED_TOKEN_HEADER = "x-renewed-token";

export const LAST_ACTIVITY_KEY = "lastActivityAt";

export const AUTH_TOKEN_KEY = "authToken";

